import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUrlFriendlyToParameters, useNavigateTo2, useGetURL, useGetRealPath } from "helpers/urlFriendly";
import { useGetLanguages } from "helpers/commonCodes";
import { useLabels } from "components/general/Label";


function Selector_Language() {

    let urlP = useParams();
    let params = useUrlFriendlyToParameters();
    const getURL = useGetURL()
    //Copy object in order to change 
    let paramsURL = { ...params }
    const fLabel = useLabels();


    const [lang, setLang] = useState(params.mirs_language);
  
    let url
    const realPath = useGetRealPath();
    let path = realPath(paramsURL.mirs_language);
    const navigate = useNavigate()
   
    const handleOnChange = (event => {
        //previousValue.language = lang;
        //i18n.changeLanguage(event.target.value)
        setLang(event.target.value)
        //Change check if is by code 
        paramsURL.mirs_language = event.target.value;
        paramsURL.mirs_competition = params.mirs_competition;
        paramsURL.mirs_discipline = params.mirs_discipline;
        paramsURL.mirs_rsc = params.mirs_rsc;
        url = getURL(paramsURL, path)
        navigate(url)

    })

    /*
    useEffect(() => {
        let _path = realPath(lang);
        setPath(_path);
        paramsURL.mirs_language = lang;
        //navigate(getURL(paramsURL, path))
        if (previousValue.language && paramsURL.mirs_language && (paramsURL.mirs_language !== previousValue.language)) {
            console.log("PARAMS", paramsURL)
            setParamsUrl(paramsURL);
            setShow(true)
        }
    }, [dataRouters])


    useEffect(() => {
        if (loaded) {
            console.log("loaded TRUE")
            paramsURL.mirs_language = lang;
            setLoaded(false)
            setParamsUrl2(paramsURL);
        }

    }, [loaded])

    useEffect(() => {
        //Wait to CC are loaded paramsCC and url is complete translate 
        if (loaded && url && url.indexOf("undefined") === -1) {
            console.log("URL has URL")
            setShouldNavigate(true);
            setShow(false)
        }
    }, [url])




    if (show) { return <Loader className="loading" text="LOADING SELECTOR LANGUAGE Common Codes" /> }
*/
    const dataLanguages = useGetLanguages()
    let options = Array.isArray(dataLanguages.languages) && dataLanguages.languages.map((item, index) => (
        <option key={"language-option-" + index} value={item?.lang}>{item?.description}</option>
    ))
    return (
        <>
            <div className="select">
                <label htmlFor="selectorLanguage" className="sr-only">{fLabel({ data: 'LabelSwitchLanguage' })}</label>
                <select
                    id="selectorLanguage"
                    value={lang}
                    onChange={handleOnChange}>
                    {options}
                </select >
            </div >
        </>
    );
}
export default Selector_Language;